import { createPortal } from 'react-dom'

import AddPoll from 'features/AddPoll/AddPoll'
import { type IPoll } from 'types/interfaces/ITypes'

interface StoryAddPollProps {
    open: boolean
    setOpen: (_set: boolean) => void
    setPollDataFunction: (_data: IPoll) => void
    background: string
}

export function StoryAddPoll({
    open,
    setOpen,
    setPollDataFunction,
    background
}: StoryAddPollProps) {
    const portal = document.getElementById('portal')

    function handleClosePoll() {
        portal?.classList.contains('portal--open') &&
            portal?.classList.remove('portal--open')
        setOpen(false)
    }
    if (!portal) return null

    if (open) {
        setTimeout(
            () =>
                !portal.classList.contains('portal--open') &&
                portal.classList.add('portal--open'),
            10
        ) // setTimeout is a workaround for white flash caused by portal showing before the poll renders
        return createPortal(
            <AddPoll
                handleClose={handleClosePoll}
                handleSetPollData={setPollDataFunction}
                noControls
                backgroundColor={background}
            />,
            portal
        )
    }
    return <></>
}
